import { __decorate } from "tslib";
import React from 'react';
import moment from 'moment';
import noop from 'lodash/noop';
import classNames from 'classnames';
import DaysView from './DaysView';
import TimesView from './TimesView';
import autobind from '../_util/autobind';
import { ViewMode } from './enum';
import { FieldType } from '../data-set/enum';
import { $l } from '../locale-context';
import { getDateFormatByFieldType } from '../field/utils';
export default class DateTimesView extends DaysView {
    constructor() {
        super(...arguments);
        this.getTimeProps = () => {
            const { format = getDateFormatByFieldType(TimesView.type) } = this.props;
            const timeProps = {
                ...this.props,
                mode: ViewMode.time,
                datetimeSide: true,
                format,
            };
            return timeProps;
        };
    }
    getViewClassName() {
        const { prefixCls } = this;
        return `${prefixCls}-datetime`;
    }
    handleTimeSelect() {
        this.changeViewMode(ViewMode.time);
    }
    handleKeyDownRight(e) {
        if (e.altKey) {
            this.changeViewMode(ViewMode.time);
        }
        else {
            this.changeSelectedDate(this.getCloneDate().add(1, 'd'));
        }
    }
    getFirstDay(date) {
        const firstDay = date.clone().subtract(1, 'M');
        const hour = firstDay.hour();
        const minute = firstDay.minute();
        const second = firstDay.second();
        firstDay.date(firstDay.daysInMonth()).startOf('w');
        firstDay.hour(hour);
        firstDay.minute(minute);
        firstDay.second(second);
        return firstDay;
    }
    choose(date, expand = true) {
        const { onSelect = noop } = this.props;
        onSelect(date, expand);
    }
    renderFooter() {
        const { prefixCls, props: { disabledNow }, } = this;
        const footerProps = {
            className: classNames(`${prefixCls}-footer-now-btn`, {
                [`${prefixCls}-now-disabled`]: disabledNow,
            }),
            onClick: !disabledNow ? this.choose.bind(this, moment(), false) : noop,
        };
        return (React.createElement("div", { className: `${prefixCls}-footer` },
            React.createElement("a", Object.assign({}, footerProps), $l('DatePicker', 'now'))));
    }
    render() {
        const { prefixCls, props: { className, extraFooterPlacement }, } = this;
        const classString = classNames(`${prefixCls}-view`, className, this.getViewClassName());
        return (React.createElement("div", { className: `${this.getViewClassName()}-wrapper` },
            React.createElement("div", { className: classString },
                this.renderHeader(),
                this.renderBody(),
                extraFooterPlacement === 'top' && this.customFooter,
                this.renderFooter(),
                extraFooterPlacement === 'bottom' && this.customFooter),
            React.createElement(TimesView, Object.assign({}, this.getTimeProps()))));
    }
}
DateTimesView.displayName = 'DateTimesView';
DateTimesView.type = FieldType.dateTime;
__decorate([
    autobind
], DateTimesView.prototype, "handleTimeSelect", null);
